import { request } from "@/api/client";

export type InsightEpisode = {
  id: string;
  summary: string;
  timestamp?: string;
  agents?: string[];
};

export type InsightSignals = {
  latest_summary?: string | null;
  last_contact?: { summary?: string | null; timestamp?: string | null } | null;
  last_promo?: { summary?: string | null; timestamp?: string | null } | null;
  last_settlement?: { summary?: string | null; timestamp?: string | null } | null;
  last_press_reference?: { summary?: string | null; timestamp?: string | null } | null;
  [key: string]: unknown;
};

export type CRMInsightResponse = {
  summary?: string | null;
  suggestions?: string[];
  episodes?: InsightEpisode[];
  episode_signals?: InsightSignals;
  tools?: Record<string, unknown> | null;
  lead?: Record<string, unknown> | null;
  event?: Record<string, unknown> | null;
  venue?: Record<string, unknown> | null;
  metadata?: Record<string, unknown> | null;
};

export function fetchLeadInsights(id: string | number): Promise<CRMInsightResponse> {
  return request<CRMInsightResponse>(`/agents/insights/lead/${encodeURIComponent(String(id))}`);
}

export function fetchEventInsights(id: string | number): Promise<CRMInsightResponse> {
  return request<CRMInsightResponse>(`/agents/insights/event/${encodeURIComponent(String(id))}`);
}

export function fetchVenueInsights(id: string | number): Promise<CRMInsightResponse> {
  return request<CRMInsightResponse>(`/agents/insights/venue/${encodeURIComponent(String(id))}`);
}
